import { type ERPItem } from '../../../integration/ERPItem'
import { type APIConfig } from '../apiTypes'
import { axiosInstance } from './axiosInstance'

const axios = axiosInstance()

/*
  The shape of the response by article status, according to Scensum's backend 2026-08-20.

  | Article status | The row in the response                                        |
  |----------------|----------------------------------------------------------------|
  | buyable        | complete, IsBuyable: true                                      |
  | not buyable    | IsBuyable: false, and the fields listed in ERPItem are missing  |
  | unknown Sku    | an object with Sku: null -- the row is NOT left out             |

  Order is preserved and nothing is deduplicated, but an empty or null Sku in the
  request drops out of the response. Always match on Sku, never on index.

  Buyability is decided per channel from the hostname of the call: the same Sku can be
  buyable in channel 1 but not in channel 2. An unknown Sku always gives HTTP 200 -- a
  400 means the whole call is broken.

  The backend caches article data for 240 minutes, negative lookups included, so a
  Sku: null can be four hours old and should not on its own be the basis for a lasting
  substitution. The cache most likely covers dsapricehelper too, but that is unconfirmed.
*/
type Response = ERPItem[]

export const postArticleinfolist = async <T = any>(args: {
  apiConfigs: APIConfig
  data: any
  onSuccess: (response: { data: Response }) => T
}): Promise<T> => {
  const { data, onSuccess } = args
  const { scensumBaseUrl } = args.apiConfigs

  return await axios<Response>({
    method: 'post',
    url: `${scensumBaseUrl}/api/v1/articleinfolist?includeArticleAttributes=true`,
    data,
  })
    .then(async (response) => onSuccess(response))
    .catch((error) => {
      console.error(error)
      throw new Error(JSON.stringify(error))
    })
}
